import React, { useRef, useState } from 'react'
import AppInput from 'components/atoms/AppInput/AppInput'
import { TemplateTabs } from '../../molecules/TemplateTabs'
import { TemplateFilters, TemplateOperationMode } from '../../../../domain/entities/Template'
import AppDate from '../../../../../components/atoms/AppDate/AppDate'

interface TemplateFilterBarProps {
    activeTab: string
    totalAllTemplates: number
    totalByClassificationType: TemplateOperationMode[]
    onTabChange: (tabId: string) => void
    fetchTemplates: (params?: TemplateFilters) => void
}

export function TemplateFilterBar({
    activeTab,
    totalAllTemplates,
    totalByClassificationType,
    onTabChange,
    fetchTemplates,
}: TemplateFilterBarProps) {
    const [dateRange, setDateRange] = useState<{ start: Date | null; end: Date | null }>({
        start: null,
        end: null,
    })
    const searchRef = useRef<string>('')

    const formatDate = (date: Date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }

    const buildFilters = (overrides: TemplateFilters = {}): TemplateFilters => ({
        ...(searchRef.current ? { name: searchRef.current } : {}),
        ...(dateRange.start && dateRange.end
            ? { created_after: formatDate(dateRange.start), created_before: formatDate(dateRange.end) }
            : {}),
        ...overrides,
    })

    const handleDateChange = (data: { start: Date | null; end: Date | null }) => {
        setDateRange(data)
        if (data.start && data.end) {
            fetchTemplates({
                ...buildFilters(),
                created_after: formatDate(data.start),
                created_before: formatDate(data.end),
            })
        }
    }

    const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            searchRef.current = (e.target as HTMLInputElement).value
            fetchTemplates(buildFilters())
        }
    }

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <TemplateTabs
                    activeTab={activeTab}
                    totalAllTemplates={totalAllTemplates}
                    totalByClassificationType={totalByClassificationType}
                    onTabChange={onTabChange}
                />
                <div className="pb-2">
                    <AppDate sendDate={handleDateChange} />
                </div>
            </div>

            <div className="w-full max-w-[350px] mb-6">
                <AppInput
                    placeholder="Buscar"
                    onKeyDown={handleSearch}
                    showSearchIcon
                />
            </div>
        </div>
    )
}
